import { useQuery } from '@tanstack/react-query'
import { Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom'
import Fields from './fields'
import Field from '../../components/field'
import Page from '../../components/layouts/page'
import Lists from './lists'
import List from '../../components/list'

const WIDE_ITEMS_LANGUAGE_THRESHOLD = 2

const Schema = ({ airline }) => {
  const { schemaID, fieldID } = useParams()
  const { pathname } = useLocation()
  const listID = pathname.match(/\/lists\/([^/]+)/)?.[1]
  const isListDetailsTab = Boolean(listID) && pathname.endsWith('/details')
  const isListItemsTab = Boolean(listID) && pathname.endsWith('/items')
  const { data: schema } = useQuery([`schemas/`, `${schemaID}`])
  const { data: collection } = useQuery({
    queryKey: ['collections/', listID],
    enabled: !!listID,
  })
  const needsWideItems = isListItemsTab && Boolean(collection?.is_localizable) && Boolean(schema?.id)
  const { data: languages } = useQuery({
    queryKey: [`languages?airlineId=${airline?.id ?? ''}&schemaId=${schema?.id ?? ''}`],
    enabled: needsWideItems,
  })
  const useNarrow =
    isListDetailsTab ||
    (isListItemsTab &&
      (!collection?.is_localizable || (languages != null && languages.length <= WIDE_ITEMS_LANGUAGE_THRESHOLD)))

  const listTabs = [
    { name: 'Details', to: `lists/${listID}/details` },
    { name: 'Items', to: `lists/${listID}/items` },
  ]
  const schemaTabs = [
    { name: 'Fields', to: `fields` },
    { name: 'Lists', to: `lists` },
  ]

  return (
    <Page
      className={useNarrow ? 'cs-page-narrow' : undefined}
      breadcrumbs={[
        { text: 'Schemas', to: '/settings/schemas' },
        { text: schema?.name, to: listID ? `/settings/schemas/${schemaID}/lists` : undefined },
        ...(listID ? [{ text: collection?.name }] : []),
      ]}
      tabs={listID ? listTabs : schemaTabs}
    >
      {schema ? (
        <Routes>
          <Route path='/fields' element={<Fields schemaID={schemaID} airline={airline} />} />
          <Route path='/fields/:fieldID' element={<Field airline={airline} schema={schema} fieldID={fieldID} />} />
          <Route path='/lists' element={<Lists schema={schema} />} />
          <Route path='/lists/:listID/*' element={<List schema={schema} />} />
          <Route path='*' element={<Navigate to={`fields`} replace={true} />} />
        </Routes>
      ) : null}
    </Page>
  )
}

export default Schema
